import { render, staticRenderFns } from "./ArtEnrollment.vue?vue&type=template&id=b1157914&scoped=true"
import script from "./ArtEnrollment.vue?vue&type=script&lang=js"
export * from "./ArtEnrollment.vue?vue&type=script&lang=js"
import style0 from "./ArtEnrollment.vue?vue&type=style&index=0&id=b1157914&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1157914",
  null
  
)

export default component.exports